// extracted by mini-css-extract-plugin
export default {"tabs":"profile-tabs_tabs__vKs3E"};